import styled from 'styled-components';

export const CenteredLoading = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`;
